module.exports = __webpack_public_path__ + "fonts/inter-v3-latin-ext_latin-regular.0ff623d.ttf";